import * as React from 'react';
import { flow } from 'lodash';
import appConfig from '../../../../config/main';
import Helmet from 'react-helmet';
import Header from './scenes/Header';
import Footer from './scenes/Footer';
import CookieAndPrivacy from './components/CookieAndPrivacy';
import { withRouter } from 'react-router';
import { IChannel } from '../../data/api/models';

interface IShellProps {
  steps: object;
  channel: IChannel;
}

interface IShellState {
  hasUserAcceptCookies: boolean;
  hideContainer: boolean;
}

class Shell extends React.Component<IShellProps, IShellState> {
  public state = {
    hasUserAcceptCookies: false,
    hideContainer: false,
  };

  public constructor(props) {
    super(props);

    if (process.env.BROWSER) {
      const accepted: boolean = window.localStorage.getItem('eu-cookie-accepted') === 'true';

      this.state = {
        hasUserAcceptCookies: accepted,
        hideContainer: accepted,
      };
    }
  }

  private handleAcceptance = () => {
    this.setState({ hasUserAcceptCookies: true });

    window.localStorage.setItem('eu-cookie-accepted', 'true');

    setTimeout((() => {
      this.setState({ hideContainer: true });
    }), 700);
  }

  public render() {
    const { children, steps, channel } = this.props;
    const { hasUserAcceptCookies, hideContainer } = this.state;
    const favicon = channel.favicon;
    const imageType = favicon && favicon.substring(favicon.length - 3);
    const renderImageType = imageType === 'ico' ? 'x-icon' : imageType;

    const brandTemplate =  {
      titleTemplate: `${channel.baseName}: %s`,
    };

    const styles = [];
    const scripts = [];
    const dedicatedChannels = [
      'tumc-b2c',
      'cpi-b2c',
    ];

    if (dedicatedChannels.indexOf(channel.key) !== -1) {
      if (process.env.NODE_ENV === 'production') {
        styles.push(`/public/css/${channel.key}.css`);
      }

      if (process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development') {
        scripts.push(`/public/js/${channel.key}.js`);
      }
    } else {
      styles.push(`/public/css/tumc-b2c.css`);
      scripts.push(`/public/js/tumc-b2c.js`);
    }

    const renderStyles = styles.map((src, i) =>
      <link key={i} rel="stylesheet" type="text/css" href={src} />,
    );

    const renderScripts = scripts.map((src, i) =>
      <script src={src} key={i} />,
    );

    return (
      <div>
        <Helmet {...appConfig.app.head} {...brandTemplate}>
          {channel.favicon && (
            <link
              rel="shortcut icon"
              type={`image/${renderImageType}`}
              href={channel.favicon}
            />
          )}
          {renderStyles}
          {renderScripts}
        </Helmet>
        {!hideContainer && (
          <div className={hasUserAcceptCookies ? 'fade-out' : ''}>
            <CookieAndPrivacy onClickEvent={this.handleAcceptance}/>
          </div>
        )}
        <Header steps={steps} channel={channel} />
        {children}
        <Footer channel={channel} />
      </div>
    );
  }
}

export default flow([
  withRouter,
])(Shell);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Shell/index.tsx